import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import Evaluation from 'models/Evaluation';
import React from 'react';
import { EVALUATION_DISPLAY_NAMES } from 'utils/types';
import { formatDate } from 'utils/utils';
import { FilterOption } from 'view/components/common/Filter';
import ItemPanel from 'view/components/common/ItemPanel';
import StatusIcon from 'view/components/common/StatusIcon';

interface TeacherEvaluationListProps {
  evaluations: Evaluation[];
  selectedEvaluation?: Evaluation;
  averages?: Record<string, any>;
  averageDisplay: FilterOption;
  onSelect: (evaluation: Evaluation) => void;
  onEnter: () => void;
  onViewSubmissions: (event: any, evaluation: Evaluation) => void;
}

const TeacherEvaluationList: React.FC<TeacherEvaluationListProps> = ({
  evaluations,
  selectedEvaluation,
  averages,
  averageDisplay,
  onSelect,
  onEnter,
  onViewSubmissions,
}) => {
  const handleClickEvaluation = (evaluation: Evaluation) => {
    if (evaluation === selectedEvaluation) {
      onViewSubmissions(new Event(''), evaluation);
    } else {
      onSelect(evaluation);
    }
  };

  return (
    <>
      {evaluations &&
        evaluations.map((evaluation) => (
          <ItemPanel
            key={`evaluation-${evaluation.id}`}
            id={`evaluation-${evaluation.id}`}
            selected={selectedEvaluation === evaluation}
            onClick={() => handleClickEvaluation(evaluation)}
            onDoubleClick={() => onViewSubmissions(new Event(''), evaluation)}
          >
            <div className="student-row-info">
              <div className="row spaced">
                <div className="row">
                  <span className="label-normal">
                    {EVALUATION_DISPLAY_NAMES[evaluation.type]} Evaluation
                  </span>
                  <StatusIcon
                    icon={faCalendar}
                    color="var(--dark-green)"
                    text="View Submissions"
                    onClick={(event) => onViewSubmissions(event, evaluation)}
                  />
                </div>
                <span className="label-small">
                  Created: {formatDate(new Date(evaluation.created_at))}
                </span>
              </div>
            </div>
          </ItemPanel>
        ))}
    </>
  );
};

export default TeacherEvaluationList;
